import { DateTime } from 'luxon';

// Helper function to convert time displayed to minutes for comparison to call schedule
export const calculateMinutesSince = (imageTimestamp: string): number => {
  try {
    const date = DateTime.fromISO(imageTimestamp, { zone: 'utc' });

    if (!date.isValid) {
      console.error('Invalid date string in calculateMinutesSince:', imageTimestamp);
      return 0;
    }

    const now = DateTime.now();
    const diffMinutes = now.diff(date, 'minutes').minutes;

    return diffMinutes;
  } catch (err) {
    console.error('Failed to calculate time difference:', err);
    return 0; // Default to 0 if calculation fails
  }
};

// Converts "2025-12-01T17:30:02.814674+00:00" to "2025-12-01 05:30:02.814 PM"
export const formatTimestamp = (imageTimestamp: string): string => {
  try {
    const date = DateTime.fromISO(imageTimestamp, { zone: 'utc' });

    if (!date.isValid) {
      console.error('Invalid date string:', imageTimestamp);
      return imageTimestamp;
    }

    // luxon format tokens: https://moment.github.io/luxon/#/formatting?id=table-of-tokens
    return date.toLocal().toFormat('yyyy-MM-dd hh:mm:ss.SSS a');
  } catch (err) {
    console.error('Error formatting timestamp:', err);
    return imageTimestamp;
  }
};

// Helper function to format time display
// Converts minutes to hours or days when appropriate
export const formatTimeAgo = (minutes: number): string => {
  const dayInMinutes = 1440
  const minutesInHour = 60
  const minutesFloor = Math.floor(minutes);

  if (minutes < minutesInHour) {
    return `${minutesFloor} minutes ago`;
  }

  if (minutes < dayInMinutes) {
    const hours = Math.floor(minutes / minutesInHour);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago (${minutesFloor} minutes)`;
  }

  // If 24 hours or more, show days
  const days = Math.floor(minutes / dayInMinutes);
  return `${days} ${days === 1 ? 'day' : 'days'} ago (${minutesFloor} minutes)`;
};
